<div class="modal-header">
  <h4 class="modal-title" i18n>Discounts</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
  <p i18n>These are your available discounts.</p>
  <table class="table table-striped">
    <thead>
      <tr>
        <th i18n>Created</th>
        <th i18n>Type</th>
        <th i18n>Discount</th>
        <th i18n>Expires</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let discount of discounts">
        <td>{{ discount.created_at | date: 'short' }}</td>
        <td>{{ discount.type | i18nSelect: discountTypes }}</td>
        <td>{{ discount.discount_percent | number: '1.0-2' }}%</td>
        <td>{{ discount.valid_till | date: 'short' }}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>